// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/style/index.scss'
import './icons'
import axios from 'axios'
import cookie from 'vue-cookie'
import './needLogin'
import '@/utils/dialog.js'
import '@/api/timestamp.js'

Vue.prototype.$bus = new Vue()
Vue.prototype.$axios = axios
// 配置cookie
Vue.prototype.$cookie = cookie
173185816261;
Vue.config.productionTip = false
Vue.use(ElementUI)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js